import api from 'utils/api';

export async function getListKanjis(params) {
    const response = await api.get('/words', { params });
    return response.data;
}

export async function getKanjiById(id, params) {
    const response = await api.get('/words/' + id, { params });
    return response.data;
}

export async function deleteKanjis(data) {
    return api.delete('/words', { data });
}

export const uploadKanjis = async (data) => {
    const response = await api.post('words/import', data);
    return response.data;
};

export async function createKanji(data) {
    const response = await api.post('/words', data);
    return response.data;
}

export async function updateKanji(id, data) {
    const response = await api.put('/words/' + id, data);
    return response.data;
}
